import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { tableDeleteButtonOffset, tableDeleteButtonSize, tableToolbarSize } from '../consts';
var DELETE_BUTTON_CONTROLS_OFFSET = tableToolbarSize + tableDeleteButtonSize + tableDeleteButtonOffset;
function getColumnOptions(left, tableWrapper) {
  return {
    alignX: 'left',
    alignY: 'start',
    offset: [left, DELETE_BUTTON_CONTROLS_OFFSET],
    shouldRenderPopup: function shouldRenderPopup() {
      if (tableWrapper) {
        var rect = tableWrapper.getBoundingClientRect();
        var maxVisibleLeftPosition = rect.width + tableWrapper.scrollLeft - tableDeleteButtonSize;
        var minVisibleLeftPosition = tableWrapper.scrollLeft;
        return maxVisibleLeftPosition - left > 0 && left > minVisibleLeftPosition;
      }
      return true;
    }
  };
}
function getRowOptions(top) {
  return {
    alignX: 'left',
    alignY: 'start',
    forcePlacement: true,
    offset: [0, -top],
    onPositionCalculated: function onPositionCalculated(position) {
      return _objectSpread(_objectSpread({}, position), {}, {
        // We need to force left to always be the offset to not be affected by overflow
        left: -DELETE_BUTTON_CONTROLS_OFFSET
      });
    }
  };
}
export default function getPopupOptions(_ref) {
  var left = _ref.left,
    top = _ref.top,
    selectionType = _ref.selectionType,
    tableWrapper = _ref.tableWrapper;
  switch (selectionType) {
    case 'column':
      return getColumnOptions(left, tableWrapper);
    case 'row':
      return getRowOptions(top);
    default:
      {
        return {};
      }
  }
}